<template>
  <register-layout
    title="회원가입 구분"
    @close="onClickClose"
    @prev="onClickPrev"
    @next="onClickNext"
  >
    <div class="privacy-consent">
      <section class="gap-y-6">
        <vs-radio
          v-for="item in registerTypeList"
          :key="item.value"
          v-model="registerType"
          :vs-value="item.value"
          style="font-size: 18px;"
          class="gap-2"
        >
          {{ item.label }}
        </vs-radio>
      </section>
    </div>
  </register-layout>
</template>

<script>
import RegisterLayout from "@/views/pages/register/RegisterLayout.vue";
import { registerTypeList } from "@/views/pages/register/RegisterTypeInfo.js";
export default {
  name: "RegisterType",
  components: {RegisterLayout},
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      registerTypeList: registerTypeList,
    };
  },
  computed: {
    registerType: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    onClickPrev() {
      this.$emit('prev');
    },
    onClickNext() {
      this.$emit('next');
    }
  }
}
</script>

<style scoped lang="scss">
section { display: grid; gap: 0.625rem; margin-bottom: 20px;}
section:last-child { margin-bottom: 48px; }
section-content {
  font-size: 18px;
}
</style>
